import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import $api from '@/utils/request'
import $wx from '@/utils/wx'
import $storage from '@/utils/storage'
import '@/utils/dynamicCreate'
import '@/components'
import '@/utils/element-ui'

Vue.config.productionTip = false
Vue.prototype.$api = $api
Vue.prototype.$wx = $wx
Vue.prototype.$storage = $storage

Vue.use(Vant);
// Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// if (process.env.NODE_ENV != 'production') {
//   let script = document.createElement('script')
//   script.setAttribute('inspect-type', 'eruda')
//   script.src = 'https://cdn.jsdelivr.net/gh/ikrong/inspect-web@master/build/js/debugger.js'
//   document.body.appendChild(script)
// }

!(() => {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  let lastTouchEnd = 0;
  document.addEventListener(
    'touchend',
    function (event) {
      let now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
})()